import React from 'react'
import styles from './SingleReport.scss'
import {ReportViewer} from '../../../ShowPage/ReportViewer'
import {connect} from 'react-redux'
import {loadTrip} from 'lib/api/trips'
import {keyIn} from 'lib/utils'
import smartDate from '@qrohlf/smart-date'
import appStyles from '../../../App/appStyles.scss'
import cx from 'classnames'
import {Navbar, NavbarGroup} from 'common/Navbar'
import Helmet from 'react-helmet'
import {Icon} from 'common/LegacyIcon'
import {VoteWidgetContainer} from './VoteWidget'
import {VoteBody} from '../VoteBody'
import {FollowButtonContainer} from 'common/FollowButton'

export class SingleReport extends React.PureComponent {
  componentDidMount () {
    const {report} = this.props
    if (report) {
      this.loadRides()
    }
  }

  componentDidUpdate (prevProps) {
    if ((prevProps.reportId !== this.props.reportId) || (!prevProps.report && this.props.report)) {
      this.loadRides()
    }
  }

  loadRides = () => {
    const {report, trips, loadTrip} = this.props
    report.rides
      .filter(id => !trips.has(id))
      .forEach(tripId => loadTrip(tripId))
  }

  render () {
    const {report, trips, onChangeRoute, votedIds, reportId, reports, finalistIds, currentUser} = this.props

    // this is a very short-lived loading state because in almost every case the
    // report will load from cache instead of over the network, so we don't show
    // a spinner since it would cause an unsettling flash/flicker effect
    if (!report) {
      return (
        <div className={cx(styles.SingleReport, appStyles.base)}>
          <Helmet title={`Finalist Voting`} />
          <Navbar>
            <NavbarGroup>
              <li><a className={styles.navLink} onClick={() => onChangeRoute(null)}>&laquo; Back to all finalists</a></li>
            </NavbarGroup>
            <NavbarGroup>
              <li>loading...</li>
            </NavbarGroup>
            <NavbarGroup>
              <li>{' '}</li>
            </NavbarGroup>
          </Navbar>

        </div>
      )
    }

    const rides = trips.filter(keyIn(report.rides))
    const votedFor = votedIds.has(reportId)
    return (
      <div className={cx(styles.SingleReport, appStyles.base)}>
        <Helmet title={`Finalist Voting · ${report.title}`} />
        <Navbar>
          <NavbarGroup>
            <li><a className={styles.navLink} onClick={() => onChangeRoute(null)}>&laquo; Back to all finalists</a></li>
          </NavbarGroup>
          <NavbarGroup>
            <li>Finalist report by {report.user.name}</li>
            {currentUser.id && currentUser.id !== report.user.id && <li><FollowButtonContainer targetUserId={report.user.id} /></li>}
          </NavbarGroup>
          <NavbarGroup>
            <li>{smartDate(report.publishedAt)}</li>
          </NavbarGroup>
        </Navbar>
        <div className={styles.header}>
          <h1 className={appStyles.title}>{report.title}</h1>
          <p className={appStyles.subtitle}>{report.subtitle}</p>
          {votedFor && <div className={styles.votedFor}><Icon i='star' size={20} /><span> You have voted for this report</span></div>}
          {!votedFor && <div className={styles.scrollDown}>
            <div>Scroll down to vote</div>
            <div><Icon i='arrowDown' size={16} /></div>
          </div>}
        </div>
        <ReportViewer report={report} rides={rides} />
        <hr />
        <VoteWidgetContainer reportId={reportId} key={reportId} />
        <div className={styles.grayBg}>
          <VoteBody
            altCountdownFill
            reports={reports}
            votedIds={votedIds}
            onChangeRoute={onChangeRoute}
            finalistIds={finalistIds} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  report: state.rideReports.reports.get(ownProps.reportId),
  trips: state.trips,
  votedIds: state.rolloutContest.votedIds,
  finalistIds: state.rolloutContest.finalistIds,
  reports: state.rideReports.reports,
  currentUser: state.currentUser
})

const mapDispatchToProps = {
  loadTrip
}

export const SingleReportContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleReport)
